import { Select } from 'jl-design-system/components/select/Select';

import { formatQuantityNumericOptions } from '../../../utils';

export const PRODUCT_QUANTITY = {
  component: Select,
  name: 'quantity',
  id: 'quantity',
  label: 'Quantity',
  options: formatQuantityNumericOptions(1, 5),
  required: false,
  className: 'fieldMedium',
};
